import { createContext, useState } from 'react';
import PropTypes from 'prop-types';

import useAuthenticatedAPIServiceCall from '@frolight/hooks/useAuthenticatedAPIServiceCall';
import { patchPreferences } from '@frolight/services/api/userService';
import useLocalizationUtils from '@frolight/hooks/useLocalizationUtils';

const LocaleContext = createContext();

export const LocaleProvider = ({ children }) => {
  const [ selectedLocale, setSelectedLocale ] = useState(null);
  const [ hasChanged, setHasChanged ] = useState(false);

  const authenticatedAPIServiceCall = useAuthenticatedAPIServiceCall();
  const { changeLocale } = useLocalizationUtils();

  const updateLocaleIfNeeded = (dbLocale) => {
    if (hasChanged && selectedLocale !== dbLocale) {
      authenticatedAPIServiceCall(patchPreferences, {
        abortController: new AbortController(),
        opts: {
          locale: selectedLocale,
        },
      });
      changeLocale(selectedLocale);
      setHasChanged(false);
      return selectedLocale;
    } else if (!hasChanged && selectedLocale !== dbLocale) {
      changeLocale(dbLocale);
    }
  };


  return (
    <LocaleContext.Provider value={{ setSelectedLocale, setHasChanged, updateLocaleIfNeeded }}>
      {children}
    </LocaleContext.Provider>
  );
};

LocaleProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default LocaleContext;
